import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const Shipping = (props) => {
  const { cartOrOrder } = props;

  const { t } = useLocalization();
  const { orderDeliveryMethod, shipping } = cartOrOrder;

  if (orderDeliveryMethod !== 'Ship') {
    return null;
  }

  if (shipping.length === 0) {
    return (
      <div className="c7-order-summary__item">
        <div className="c7-order-summary__title">
          {t('checkout.delivery.shipping')}
        </div>
        <div className="c7-order-summary__value">
          {t('checkout.general.calculatedAtCheckout')}
        </div>
      </div>
    );
  }

  return shipping.map((shipItem) => (
    <div key={shipItem.id} className="c7-order-summary__item">
      <div className="c7-order-summary__title">
        {t('checkout.delivery.shipping')} ({shipItem.title})
      </div>
      <div className="c7-order-summary__value">
        <ShipPrice shipping={shipItem} />
      </div>
    </div>
  ));
};

const ShipPrice = (props) => {
  const { shipping } = props;

  const settings = useSelector((state) => state.setting.data);

  const { currency } = settings;
  const { originalPrice, price } = shipping;

  if (originalPrice > price) {
    return (
      <>
        <span className="c7-price--original">
          <span className="c7-sr-only">Was </span>
          {currencyFormat(originalPrice, currency)}
        </span>
        <span className="c7-price--discounted">
          <span className="c7-sr-only">Now </span>
          {currencyFormat(price, currency)}
        </span>
      </>
    );
  }
  return currencyFormat(price, currency);
};

export default Shipping;
